import { ButtonBase, Stack } from "@mui/material";

import { type PaymentsListItem } from "../types/PaymentsListItem";
import { PaymentsListItemAmount } from "./PaymentsListItemAmount";
import { PaymentsListItemBadge } from "./PaymentsListItemBadge";
import { PaymentsListItemDescription } from "./PaymentsListItemDescription";
import { PaymentsListItemPill } from "./PaymentsListItemPill";
import { PaymentsListItemTitle } from "./PaymentsListItemTitle";

export interface PaymentsListItemProps {
  item: PaymentsListItem;
  onClick: (item: PaymentsListItem) => void;
}

export function PaymentsListItemComponent(props: PaymentsListItemProps) {
  const { item, onClick } = props;

  return (
    <ButtonBase
      data-testid={`payment-item-${item.id}`}
      sx={(theme) => ({
        width: "100%",
        paddingX: theme.spacing(5),
        paddingY: theme.spacing(4),
        flexDirection: "row",
        textAlign: "left",
      })}
      onClick={() => {
        onClick(item);
      }}
    >
      <PaymentsListItemBadge item={item} />
      <Stack
        gap={2}
        sx={(theme) => ({
          flex: 1,
          minHeight: theme.spacing(9),
          alignItems: "flex-start",
          justifyContent: "center",
          marginLeft: theme.spacing(4),
          marginRight: theme.spacing(3),
        })}
      >
        <PaymentsListItemTitle item={item} />
        <PaymentsListItemDescription item={item} />
      </Stack>
      <Stack
        gap={2}
        sx={(theme) => ({
          minHeight: theme.spacing(9),
          alignItems: "flex-end",
          justifyContent: "center",
        })}
      >
        <PaymentsListItemAmount item={item} />
        <PaymentsListItemPill item={item} />
      </Stack>
    </ButtonBase>
  );
}
